import _ from "lodash";

const pickDeep = (collection, predicate, res) =>
  _.transform(collection, (memo, val, key) => {
    if (_.isObject(val)) {
      val = pickDeep(val, predicate, res);
    }
    if (_.isArray(collection)) {
      memo.push(val);
    } else {
      memo[key] = val;
    }
    if (key === predicate) {
      res.push(val);
    }
  });

export default pickDeep;



// WEBPACK FOOTER //
// ./src/utils/nodeUtil.js